import { Outlet, useLocation } from "react-router-dom"
import { MainLayout } from "../components/layout/MainLayoutV2"
import { DashboardHome } from "../components/DashboardHome"
import { isGlobalSettingsRoute } from "../utils/routeSync"
import { Box } from "@chakra-ui/react"

interface DashboardProps { }

export const Dashboard = ({ }: DashboardProps) => {
  const location = useLocation()
  const isOnGlobalSettings = isGlobalSettingsRoute(location.pathname)
  const isRootPath = location.pathname === "/"
  return (
    <Box fontFamily={"montserrat !important"} overflow="hidden !important">
      <MainLayout outletContent={isOnGlobalSettings ? <Outlet /> : isRootPath ? <DashboardHome /> : null} />
      {/* For non-settings routes, render Outlet as overlay (for modals) */}
      {!isOnGlobalSettings && !isRootPath && <Outlet />}
    </Box>
  )
}
